import React, { Component, useEffect, useState } from 'react'
import injectSheet from 'react-jss'
import styles, { joinSchoolModalStyles } from './form.styles'
import Segment from '../../../../../shared/segment/segment'
import Segments from '../../../../../shared/segments/segments'
import Description from '../../../../../shared/description/description'
import Button from 'pobble-components/dist/button'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import { URLS } from 'pobble-components/dist/setup'
import InfoModal from 'pobble-components/dist/modal/info-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSchool } from '@fortawesome/pro-solid-svg-icons/faSchool'
import { apiUpdateRole } from '../../../../../../common/api/profile'
import { errorHandler } from 'pobble-components/dist/error-handler'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import { apiGetKeys } from '../../../../../../common/api/system'
import Bone from 'pobble-components/dist/bone'

const JoinSchoolModal = injectSheet(joinSchoolModalStyles)(
  ({ classes, ...props }) => {
    const [selectedRole, setSelectedRole] = useState('teacher_in_school')
    const [pending, setPending] = useState(false)
    const [roles, setRoles] = useState(null)

    useEffect(() => {
      apiGetKeys({ include: 'role_values' })
        .then(res => {
          setRoles(res.data.role_values.filter(role => role.type === 'teacher'))
        })
        .catch(errorHandler)
    }, [])

    return (
      <InfoModal
        className={classes.container}
        icon={<FontAwesomeIcon icon={faSchool} />}
        {...props}>
        <form
          onSubmit={e => {
            e.preventDefault()
            setPending(true)
            apiUpdateRole({
              role_in_life: selectedRole,
              finish_teacher_signup_required: true
            })
              .then(() => (window.location = `${URLS.AUTH}/finish-signup`))
              .catch(errorHandler)
          }}>
          <p className={classes.desc}>
            Before you join a school
            <br />
            please select your role below.
          </p>
          <div className={classes.select}>
            {!roles && <Bone btn />}
            {roles && (
              <FormSelect
                value={selectedRole}
                onChange={e => setSelectedRole(e.target.value)}
                className={classes.select}>
                {roles.map(role => {
                  return <option value={role.name}>{role.title}</option>
                })}
              </FormSelect>
            )}
          </div>
          <Button
            pending={pending}
            type="submit"
            tall
            className={classes.button}>
            {!pending && 'Set my role'}
            {pending && 'Setting...'}
          </Button>
          <Button tall simple action={props.requestClose}>
            Close
          </Button>
        </form>
      </InfoModal>
    )
  }
)

class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
      schools: [],
      requested: this.props.pendingTeacher,
      joinSchoolModal: { isOpen: false }
    }
  }

  getSchools(value, cb) {
    this.props
      .onSearchChange(value)
      .then(({ data }) => this.setState({ schools: data.schools }))
  }

  requestAccess = () => {
    this.props.onSubmit()
  }

  cancelRequest = () => {
    this.props
      .onRemove(this.props.userId)
      .then(() => (window.location = `${URLS.AUTH}/finish-signup`))
  }

  render() {
    const { classes, pendingTeacherSchool, userId } = this.props
    return (
      <div>
        {!this.state.requested && (
          <Segments>
            <Segment size="L">
              <Button
                className={classes.requestSchoolAccessButton}
                tall
                action={() =>
                  this.setState({
                    ...this.state,
                    joinSchoolModal: { isOpen: true }
                  })
                }>
                Request to join a school
              </Button>
            </Segment>
            <Segment size={'S'}>
              <Description>
                <p>
                  You are currently a standard user.
                  <br />
                  <br /> As a teacher you will be able to find great resources
                  and WAGOLLs, publish your pupils' work, use pupil logins for
                  peer assessment and moderate writing on Pobble. See{' '}
                  <a
                    href="https://www.pobble.com"
                    target="_blank"
                    rel="noopener noreferrer">
                    pobble.com
                  </a>{' '}
                  for more details.
                </p>
              </Description>
            </Segment>
          </Segments>
        )}
        {this.state.requested && (
          <div>
            <p className={classes.success}>
              Requested to join {pendingTeacherSchool || 'a school'}.
            </p>
            <Button
              short
              secondary
              className={classes.cancelBtn}
              action={() =>
                openConfirmationDialog({
                  bodyText: `Are you sure you want to cancel this request?`,
                  confirmText: 'Yes, continue',
                  action: () => this.cancelRequest(userId)
                })
              }>
              Cancel request
            </Button>
          </div>
        )}
        <JoinSchoolModal
          isOpen={this.state.joinSchoolModal.isOpen}
          requestClose={() =>
            this.setState({ ...this.state, joinSchoolModal: { isOpen: false } })
          }
        />
      </div>
    )
  }
}

export default injectSheet(styles)(Form)
